const { pendo } = window;

export type PendoConfig = {
  visitor: {
    id: string | number;
  };
  account: {
    id: string;
  };
};

export const initPendo = (params: PendoConfig) => {
  const { visitor, account } = params;
  pendo.initialize({
    visitor,
    account
  });
};
